export default {
    MAX_TASK_NAME_LENGTH: 64,
    ATTRIBUTE_DIFFICULTY: "difficulty",
    ATTRIBUTE_IMPORTANCE: "importance",
    ATTRIBUTE_FUN: "fun"
};
